export const configJSON = {
  headers: {
    "Content-Type": "application/json",
  },
};
